import { BrowserWebSocket } from './BrowserWebSocket.js';
import { DXTPClientConnection } from '../common/DXTPClientConnection.js';
export class BrowserDXTPClientConnection extends DXTPClientConnection {
    constructor(options) {
        super({ ...options, ...{ socketFactory: (address) => new BrowserWebSocket(address) } });
    }
}
//# sourceMappingURL=BrowserDXTPClientConnection.js.map